import React, {PureComponent} from 'react';
import {withRouter} from 'react-router-dom';

import styles from './styles';

class NavToggle extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      menuActive: false
    };
  }

  handleClick = () => {
    const {onClick} = this.props;

    onClick(!this.state.menuActive);

    // Flip the active state
    this.setState({
      menuActive: !this.state.menuActive
    });
  };

  componentDidUpdate(prevProps) {

    if (this.props.location !== prevProps.location && this.state.menuActive) {
      this.handleClick();
    }
  }

  render() {
    const classes = [styles.navToggle];

    if (this.state.menuActive) {
      classes.push(styles.navToggleActive);
    } else {
      classes.push(styles.navToggleInactive);
    }

    return (
      <div className={classes.join(' ')} onClick={this.handleClick}>
        <div className={styles.navToggleHamburger} />
      </div>
    );
  }
}

export default withRouter(NavToggle);



// WEBPACK FOOTER //
// ./src/components/NavToggle/index.jsx